import { render, staticRenderFns } from "./modalMapa.vue?vue&type=template&id=61dd2c91&scoped=true&"
import script from "./modalMapa.vue?vue&type=script&lang=js&"
export * from "./modalMapa.vue?vue&type=script&lang=js&"
import style0 from "./modalMapa.vue?vue&type=style&index=0&id=61dd2c91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd2c91",
  null
  
)

export default component.exports